import  types from "../../utils/actionTypes";
import { createReducer } from "./helperReducer";

//account reducers
export const initialState = {
  currentUser: {
    email: "",
    isAuthenticated: false,
  },
};

const setAccountField = (state, { field }) => {
  return {
    ...state,
    ...field,
  };
};

const auth = createReducer(initialState, {
  [types.SET_ACCOUNT_FIELD]: setAccountField,
});

export default auth;
